export const ELM_TAGS = [
  { value: '[user:user-first-name]', label: 'First Name' },
  { value: '[user:user-middle-name]', label: 'Middle Name' },
  { value: '[user:user-last-name]', label: 'Last Name' },
  { value: '[client:name]', label: 'Client Name' }
];
